var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 10.35C20.8889 6.13125 18.4889 4.5 16.1 4.5C14.0555 4.5 13.0222 5.1525 12 6.44625C10.9778 5.1525 9.94442 4.5 7.89997 4.5C5.51108 4.5 3.11108 6.12 3.11108 10.35C3.11108 13.6125 6.86664 18.135 11.9889 20.25C17.1111 18.135 20.8666 13.6125 20.8666 10.35H20.8889Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.5L11 12.5",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.5H23",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiced);
export default __webpack_public_path__ + "static/media/piced.62942f6f371a9f459e6489264ed725f6.svg";
export { ForwardRef as ReactComponent };